import React from 'react';
import { BsArrowLeft } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { Button, HStack, Icon, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CypressIds } from '../../../constants/cypressIds';
import { hideModal, modalGoBack, selectModalButtons, selectModalData, selectModalOpen, selectModalPreviousState } from '../../../redux/modules/modal';

const ModalContainer = ({ children = null }) => {
  const {
    actionRequired,
    title,
    size,
    maxWidth,
    maxW,
    center,
    onClose,
    variant,
    borderProps
  } = useSelector(selectModalData);

  const {
    component,
    componentOptions,
    primaryButtonOptions,
    secondaryButtonOptions,
    withHistoryButton
  } = useSelector(selectModalButtons);

  const dispatch = useDispatch();
  const previousState = useSelector(selectModalPreviousState);
  const isOpen = useSelector(selectModalOpen);
  const close = () => {
    onClose();
    dispatch(hideModal());
  };

  const ButtonComponent = component;

  const contentProps = { ...((maxW || maxWidth) && { maxW: maxW || maxWidth }) };

  return (
    <Modal
      closeOnBlur={!actionRequired}
      closeOnOverlayClick={!actionRequired}
      isOpen={isOpen}
      minH="350px"
      px={4}
      size={size}
      variant={variant}
      onClose={close}
      onOverlayClick={() => {
        if (actionRequired) {
          return;
        }

        close();
      }}
    >
      <ModalOverlay />

      <ModalContent
        onScroll={e => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onTouchMove={e => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onWheel={e => {
          e.stopPropagation();
        }}
        {...contentProps}
        {...borderProps}
      >
        {(previousState && withHistoryButton) && (
          <Button
            isRound
            fontSize="xs"
            leftIcon={<Icon as={BsArrowLeft} boxSize="18px" />}
            marginRight="5%"
            size="sm"
            variant="accent"
            width="75px"
            onClick={() => dispatch(modalGoBack())}
          >
            Back
          </Button>
        )}
        <ModalHeader
          as={HStack}
          display={title ? 'flex' : 'none'}
          justifyContent={center ? 'center' : 'flex-start'}
          mt={!withHistoryButton && '32px'}
        >
          <Text textAlign={center ? 'center' : 'left'}>{ title }</Text>
        </ModalHeader>

        {!actionRequired && <ModalCloseButton data-cy={CypressIds.closeModalButton} onClick={close} />}

        <ModalBody textAlign={center ? 'center' : 'left'}>
          { children }
        </ModalBody>

        {component && (
        <ModalFooter justifyContent={center && 'center'}>

          <ButtonComponent
            {...componentOptions}
            {...primaryButtonOptions}
            {...secondaryButtonOptions}
          />
        </ModalFooter>

        )}

      </ModalContent>
    </Modal>
  );
};

ModalContainer.propTypes = { children: PropTypes.node.isRequired };

export default ModalContainer;
